import { getIsStatusFundedOrEval } from '@/features/vest-capital/utils/status';
import { getCapitalMaxLeverage } from '@/hooks/use-funded-account';
import { useAccountStore } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';

export const getInitMarginRatio = (symbol: string, address?: string) => {
  let leverage = useMarketStore(symbol).getState().leverage || 1;
  const capitalMaxLeverage = getCapitalMaxLeverage(symbol);
  if (leverage > capitalMaxLeverage) {
    const { address: storeAddress, getCapitalStatus } =
      useAccountStore.getState();
    const capitalStatus = getCapitalStatus(address ?? storeAddress);
    const isFundedOrEval = getIsStatusFundedOrEval(capitalStatus);
    if (isFundedOrEval) {
      leverage = capitalMaxLeverage;
    }
  }
  return 10n ** 4n / BigInt(leverage);
};
